export default __webpack_public_path__ + "static/media/kuberth.a5de2279.png";